<div class="wrap-blockui-header" *blockUI="'header'"></div>
<mat-toolbar class="main-header" color="primary" *ngIf="!(autoLogin$|async)">
  <button (click)="toggleSidenav.emit()" mat-icon-button>
    <mat-icon>menu</mat-icon>
  </button>
  <div class="branding">
    <app-logo-bigger [small]="true"></app-logo-bigger>
  </div>
  <div class="search-bar" fxFlex>
    <form class="search-form" [ngStyle.xs]="{display: 'none'}">
      <mat-icon class="mat-icon-rtl-mirror">search</mat-icon>
      <input  (keyup)="toggleAutoComplete()"  (click)="toggleAutoComplete()" type="text" pInputText placeholder="Search" autofocus="true"  [matAutocomplete]="auto" name="searchMenu" (ngModelChange)="onSearchChanged($event)" [ngModel]="searchText" />
      <mat-autocomplete (optionActivated)="onOptionActivate($event)" (optionSelected)="onSelectionChanged($event)" autoActiveFirstOption #auto="matAutocomplete">
        <mat-option (click)="onMenuItemClick(option)"  *ngFor="let option of autoCompleateResults" [value]="option.label" [routerLink]="option.routerLink">
          {{option.label + ' | ' + option.automationId}}
        </mat-option>
      </mat-autocomplete>

      <!-- <button (click)="toggleSearch()"  mat-icon-button></button> -->
    </form>
  </div>
  <button (click)="openNavigateCRMDDialog(navigateCRMDaialog)"
          class="open-pos-btn"
          mat-stroked-button>
    Open POS
  </button>
  <div class="ml-1 mr-1">
    <div>{{currentUser?.siteName}}</div>
    <div style="height: 12px;font-size: 12px;line-height: 12px;">{{currentUser?.firstName}}&nbsp;{{currentUser?.lastName}}</div>
  </div>
  <button (click)="goToHomepage()" mat-icon-button>
    <mat-icon>homepage</mat-icon>
  </button>
  <button (click)="fullScreenToggle()" class="header-fullscreen-btn" mat-icon-button>
    <mat-icon>fullscreen</mat-icon>
  </button>
  <button (click)="clearCache()" class="header-sync-btn" mat-icon-button>
    <mat-icon style="transform: rotate(90deg)">sync</mat-icon>
  </button>
  <button mat-icon-button (click)="logoutButtonTapHandler(areYouSureDialog)">
    <mat-icon>exit_to_app</mat-icon>
  </button>
</mat-toolbar>

<ng-template #areYouSureDialog>
  <h1 mat-dialog-title>{{tranKey(moi.SYSTEM, systemMessagesEnum.AreYouSureLogOut) | translate}}</h1>

  <div mat-dialog-actions>
    <button mat-button (click)="areYouSureDialogRef.close()">{{tranKey(moi.SYSTEM, systemMessagesEnum.No) | translate}}</button>
    <button mat-button (click)="logoutButtonTap()"  cdkFocusInitial>{{tranKey(moi.SYSTEM, systemMessagesEnum.Yes) | translate}}</button>
  </div>
</ng-template>

<ng-template #navigateCRMDaialog>
  <h1 mat-dialog-title>{{tranKey(moi.SYSTEM, systemMessagesEnum.navigateCRMHeader) | translate}}</h1>
  <div mat-dialog-content>
    {{tranKey(moi.SYSTEM, systemMessagesEnum.areYouSureNavigateCRM) | translate}}
    <br>
    {{tranKey(moi.SYSTEM, systemMessagesEnum.unsavedDataWillBeLost) | translate}}
  </div>
  <div mat-dialog-actions>
    <button mat-button
            (click)="navigateCRMDaialogRef.close()">{{tranKey(moi.SYSTEM, systemMessagesEnum.No) | translate}}</button>
    <button mat-button
            cdkFocusInitial
            (click)="navigateCRM()">{{tranKey(moi.SYSTEM, systemMessagesEnum.Yes) | translate}}</button>
  </div>
</ng-template>

